import PermissionButton from '../../permissions/PermissionButton';
import React, { useEffect } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { useUpdateEntrepot } from '../../hooks/entrepotHooks';
import { useFetchEntrepotByCode } from '../../hooks/entrepotHooks';
import { useNavigate } from 'react-router-dom';

const EntrepotUpdateForm = ({ code_ent }) => {
  const [form] = Form.useForm();
  const { update, loading } = useUpdateEntrepot();
  const { entrepot, loading: loadingEntrepot } = useFetchEntrepotByCode(code_ent);
  const navigate = useNavigate();

  useEffect(() => {
    if (entrepot) {
      form.setFieldsValue({
        code_ent: entrepot.code_ent,
        name: entrepot.name
      });
    }
  }, [entrepot, form]);

  const handleSubmit = async (values) => {
    try {
      await update(code_ent, values);
      message.success('Entrepôt modifié avec succès');
      navigate('/entrepot');
    } catch (error) {
      message.error(error.response?.data?.message || error.message || 'Erreur lors de la modification');
    }
  };

  if (loadingEntrepot) return <p>Chargement...</p>;

  return (
    <Card title="Modifier l'Entrepôt" bordered={false} style={{ width: '100%', maxWidth: 600 }}>
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label="Code Entrepôt"
          name="code_ent"
          rules={[
            { required: true, message: 'Veuillez saisir le code entrepôt!' },
            { pattern: /^[A-Za-z0-9]+$/, message: 'Le code doit contenir uniquement des lettres et chiffres' }
          ]}
        >
          <Input placeholder="Ex: 1, 2, ENT1..." />
        </Form.Item>
        <Form.Item
          label="Nom"
          name="name"
          rules={[{ required: true, message: 'Veuillez saisir le nom!' }]}
        >
          <Input placeholder="Ex: Entrepôt Principal..." />
        </Form.Item>
        <Form.Item>
          <PermissionButton permissionModule="warehouses" permissionAction="update" type="primary" htmlType="submit" loading={loading}>
            Modifier
          </PermissionButton>
          <Button style={{ marginLeft: 8 }} onClick={() => navigate('/entrepot')}>
            Annuler
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default EntrepotUpdateForm;

